import React from 'react';

import Money from 'components/Money';

import './styles.css';

const Totals = ({invoice}) => {
  return (
    <div className="Totals">
      <div className="section">
        <div className="header">Subtotal</div>
        <div className="value">
          <Money amount={invoice.totalExcludingTax} />
        </div>
      </div>
      <div className="section">
        <div className="header">Total Vat</div>
        <div className="value">
          <Money
            amount={(
              invoice.totalIncludingTax - invoice.totalExcludingTax
            ).toFixed(2)}
          />
        </div>
      </div>
      <div className="section">
        <div className="header">Total</div>
        <div className="value">
          <Money amount={invoice.totalIncludingTax} />
        </div>
      </div>
    </div>
  );
};

export default Totals;
